import clsx from "clsx";
import React, { FC } from "react";

export interface HeroSliderDotsProps {
  className?: string;
  /**
   * Number of slides
   */
  count: number;
  /**
   * Active slide index
   */
  activeIndex: number;
  /**
   * Callback when user clicks on a dot
   * @param newIndex the new slide index
   */
  onSelect?: (newIndex: number) => void;
}

export const HeroSliderDots: FC<HeroSliderDotsProps> = ({
  className,
  count,
  activeIndex,
  onSelect,
}) => {
  const handleSelect = (index: number) => {
    if (index !== activeIndex) {
      onSelect?.(index);
    }
  };

  return (
    <div className={clsx("flex flex-row gap-3", className)}>
      {new Array(count).fill(null).map((_, index) => (
        <div
          key={index}
          onClick={() => handleSelect(index)}
          className={clsx(
            "rounded-full w-2 h-2 border border-white transition-colors",
            index === activeIndex ? "bg-white" : "cursor-pointer"
          )}
        />
      ))}
    </div>
  );
};
